// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"307":"34e7d245","481":"a8cd6cdd","610":"cf7b728a","686":"d229b3e8","739":"cf7b728a"}[chunkId] + ".chunk.css";
};